import managerTypes from './manager.types';
export default {
  fetchSupportersLoading: state =>
    state.type === managerTypes.UPLOAD_SUPPORTERS_REQUEST,
  fetchSupportersSuccess: state =>
    state.type === managerTypes.FETCH_SUPPORTERS_SUCCESS,
  fetchSupportersFailed: state =>
    state.type === managerTypes.FETCH_SUPPORTERS_FAILED,

    fetchWelcomeLoading: state =>
    state.type === managerTypes.FETCH_WELCOME_REQUEST,
  fetchWelcomeSuccess: state =>
    state.type === managerTypes.FETCH_WELCOME_SUCCESS,
  fetchWelcomeFailed: state =>
    state.type === managerTypes.FETCH_WELCOME_FAILED,

  fetchEmployeesLoading: state =>
    state.type === managerTypes.FETCH_EMPLOYEES_REQUEST,
  fetchEmployeesSuccess: state =>
    state.type === managerTypes.FETCH_EMPLOYEES_SUCCESS,
  fetchEmployeesFailed: state =>
    state.type === managerTypes.FETCH_EMPLOYEES_FAILED,
  fetchManagerLoading: state =>
    state.type === managerTypes.FETCH_manager_REQUEST,
  fetchManagerSuccess: state =>
    state.type === managerTypes.FETCH_manager_SUCCESS,
  fetchManagerFailed: state => state.type === managerTypes.FETCH_manager_FAILED
};
